"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconUpload', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M4.29289 5.70711C4.68342 6.09763 5.31658 6.09763 5.70711 5.70711L7 4.41421V10C7 10.5523 7.44772 11 8 11 8.55228 11 9 10.5523 9 10V4.41421L10.2929 5.70711C10.6834 6.09763 11.3166 6.09763 11.7071 5.70711 12.0976 5.31658 12.0976 4.68342 11.7071 4.29289L8.70711 1.29289C8.31658.902369 7.68342.902369 7.29289 1.29289L4.29289 4.29289C3.90237 4.68342 3.90237 5.31658 4.29289 5.70711zM4 12C4 11.4477 3.55228 11 3 11 2.44772 11 2 11.4477 2 12V14C2 14.5523 2.44772 15 3 15H13C13.5523 15 14 14.5523 14 14V12C14 11.4477 13.5523 11 13 11 12.4477 11 12 11.4477 12 12V13H4V12z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M5.29289 6.70711C5.68342 7.09763 6.31658 7.09763 6.70711 6.70711L9 4.41421V14C9 14.5523 9.44772 15 10 15 10.5523 15 11 14.5523 11 14V4.41421L13.2929 6.70711C13.6834 7.09763 14.3166 7.09763 14.7071 6.70711 15.0976 6.31658 15.0976 5.68342 14.7071 5.29289L10.7071 1.29289C10.3166.902369 9.68342.902369 9.29289 1.29289L5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711zM5 16C5 15.4477 4.55228 15 4 15 3.44772 15 3 15.4477 3 16V18C3 18.5523 3.44772 19 4 19H16C16.5523 19 17 18.5523 17 18V16C17 15.4477 16.5523 15 16 15 15.4477 15 15 15.4477 15 16V17H5V16z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M6.29289 7.70711C6.68342 8.09763 7.31658 8.09763 7.70711 7.70711L11 4.41421V17C11 17.5523 11.4477 18 12 18 12.5523 18 13 17.5523 13 17V4.41421L16.2929 7.70711C16.6834 8.09763 17.3166 8.09763 17.7071 7.70711 18.0976 7.31658 18.0976 6.68342 17.7071 6.29289L12.7071 1.29289C12.3166.902369 11.6834.902369 11.2929 1.29289L6.29289 6.29289C5.90237 6.68342 5.90237 7.31658 6.29289 7.70711zM6 20C6 19.4477 5.55228 19 5 19 4.44772 19 4 19.4477 4 20V22C4 22.5523 4.44772 23 5 23H19C19.5523 23 20 22.5523 20 22V20C20 19.4477 19.5523 19 19 19 18.4477 19 18 19.4477 18 20V21H6V20z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M8.43115 9.9524C9.01238 10.5427 9.9621 10.5501 10.5524 9.96884L14.5 6.08197V22.4C14.5 23.2284 15.1716 23.9 16 23.9 16.8284 23.9 17.5 23.2284 17.5 22.4V6.082L21.4476 9.96884C22.0379 10.5501 22.9876 10.5427 23.5689 9.9524 24.1501 9.36209 24.1427 8.41237 23.5524 7.83114L17.0524 1.43114C16.4685.856275 15.5314.856277 14.9476 1.43114L8.44759 7.83114C7.85728 8.41237 7.84992 9.36209 8.43115 9.9524zM8 26.5C8 25.6716 7.32843 25 6.5 25 5.67157 25 5 25.6716 5 26.5V29.5C5 30.3284 5.67157 31 6.5 31H25.5C26.3284 31 27 30.3284 27 29.5V26.5C27 25.6716 26.3284 25 25.5 25 24.6716 25 24 25.6716 24 26.5V28H8V26.5z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;